module.exports = __webpack_public_path__ + "fonts/oswald-semi-bold.9673891.woff2";